<form class="plan-sort-by-form">
  <mat-button-toggle-group
    [formControl]="formControls.sortBy"
    [hideSingleSelectionIndicator]="true"
    name="planSortByAttribute"
    aria-label="Sort Plans By Attribute"
    class="sort-by-button-toggle-group"
    >
    @for (sort of sorts; track sort; let last = $last) {
      <mat-button-toggle
        [value]="sort"
      >{{sort.displayContent}}</mat-button-toggle>
    }
  </mat-button-toggle-group>
</form>
